(function () {
  'use strict';

  var originalFetch = window.fetch;

  window.fetch = function (url, options) {
    var isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

    // Controlla subito se è già l'omaggio, prima di fare il fetch
    var isGift = false;
    try {
      var body = options && options.body ? JSON.parse(options.body) : null;
      isGift = body && body.properties && body.properties['_omaggio'] === 'true';
    } catch (e) {}

    var result = originalFetch.apply(this, arguments);

    if (isCartAdd && !isGift) {
      // Clona la promise senza toccare la Response
      result
        .then(function (response) {
          // Controlla che la risposta sia ok prima di aggiungere l'omaggio
          if (!response.ok) return;
          var variantId = getSelectedGiftVariantId();
          if (!variantId) return;
          setTimeout(function () {
            updateGiftInCart(variantId)
              .then(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                // Compatibilità Minimog
                document.dispatchEvent(new CustomEvent('theme:cart:open'));
                if (window.MinimogTheme && window.MinimogTheme.CartDrawer) {
                  window.MinimogTheme.CartDrawer.refresh();
                }
              })
              .catch(function (err) {
                console.warn('[Gift Product] ' + err.message);
              });
          }, 600);
          // IMPORTANTE: ritorna la response intatta per non consumarla
          return response;
        })
        .catch(function () {});
    }

    return result;
  };

  function getSelectedGiftVariantId() {
    var checked = document.querySelector(
      '#gift-product-section input[name="gift_variant_id"]:checked'
    );
    return checked ? parseInt(checked.value, 10) : null;
  }

  function addGiftToCart(variantId) {
    return originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _omaggio: 'true' }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Errore aggiunta omaggio');
      return res.json();
    });
  }

  function updateGiftInCart(newVariantId) {
    return originalFetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var existingGifts = cart.items.filter(function (item) {
          return item.properties && item.properties['_omaggio'] === 'true';
        });

        if (existingGifts.length === 0) {
          return addGiftToCart(newVariantId);
        }

        var sameVariant = existingGifts.find(function (item) {
          return item.variant_id === newVariantId;
        });
        if (sameVariant) return Promise.resolve();

        var updates = {};
        existingGifts.forEach(function (item) {
          updates[item.key] = 0;
        });

        return originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return addGiftToCart(newVariantId); });
      });
  }

  function updateGiftImage(radio) {
    var img = document.querySelector('#gift-product-section .gift-section-image img');
    if (!img) return;
    var newSrc = radio.getAttribute('data-image');
    if (newSrc) img.src = newSrc;
  }

  function init() {
    var giftSection = document.getElementById('gift-product-section');
    if (!giftSection) return;

    var radios = giftSection.querySelectorAll('.gift-variant-radio');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        giftSection.querySelectorAll('.gift-variant-label').forEach(function (lbl) {
          lbl.classList.remove('is-selected');
        });
        radio.closest('.gift-variant-label').classList.add('is-selected');
        updateGiftImage(radio);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();